<div class="col-xs l-plr-0 l-pt-2 l-pb-2">
  @if (!labelRef) { @if (toolTipString !== '') {
  <div class="col-xs row l-plr-0 cds-color-navy-light3 middle-xs">
    <div class="l-mr-2">
      <span class="cds-body2">{{ label | lang }}</span>
    </div>
    <cds-icon
      class="icon-margin"
      icon="action:info_1"
      (mouseenter)="onCanDelegateAmtToggle($event)"
      (mouseleave)="onCanDelegateAmtToggle($event)"
      cdsTooltip="{{ toolTipString | lang }}"></cds-icon>
  </div>
  } @if (toolTipString === '') {
  <div class="cds-color-navy-light3">
    <span class="cds-body2">{{ label | lang }}</span>
  </div>
  } }

  <!-- custom label -->
  @if (!!labelRef) {
  <div class="l-mt-1 min-height">
    <ng-container [ngTemplateOutlet]="labelRef.templateRef"></ng-container>
  </div>
  } @if (!contentRef) { @if (icon !== undefined) {
  <div (click)="call()" class="row l-plr-0 l-mt-1 pointer">
    <span class="cds-body1 l-mb-0">{{ data }}</span>
    <span class="l-mr-2"></span>
    <cds-icon class="amount-icon" width="20px" height="20px" [color]="iconColor" [icon]="icon"></cds-icon>
  </div>
  } @if (icon === undefined && checked === undefined) {
  <div class="l-mt-1">
    <span class="cds-body1">{{ data ?? '&nbsp;' }}</span>
  </div>
  } @if (icon === undefined && checked !== undefined) {
  <div class="l-mt-1">
    @if (!checked) {
    <cds-checkbox [config]="noCheckConfig"></cds-checkbox>
    } @if (checked) {
    <cds-checkbox [config]="checkedConfig"></cds-checkbox>
    }
  </div>
  } }

  <!-- custom content -->
  @if (!!contentRef) {
  <div class="l-mt-1 min-height">
    <ng-container [ngTemplateOutlet]="contentRef.templateRef"></ng-container>
  </div>
  }
</div>
